import React, { useEffect, useState } from 'react';
import { assessPhotoQuality } from '../../utils/photoQuality';
import { isScanImage } from '../../utils/scanImage';

/** Problems with the chosen photo of a blood report (none for a PDF, another record type, or a photo that is fine). */
export function usePhotoQuality(file, recordType) {
  const [problems, setProblems] = useState([]);
  useEffect(() => {
    let cancelled = false;
    setProblems([]);
    if (file && recordType === 'BLOOD_TEST') {
      assessPhotoQuality(file).then((p) => { if (!cancelled) setProblems(p); });
    }
    return () => { cancelled = true; };
  }, [file, recordType]);
  return problems;
}

/** Warns, never blocks: an unreadable photo still goes to a navigator, who reads the original. */
export default function PhotoQualityNotice({ problems, file, recordType }) {
  if (!problems?.length) {
    // a photo that passed the check is still less reliable than the lab's own PDF
    if (!(file && recordType === 'BLOOD_TEST' && isScanImage(file.type))) return null;
    return (
      <div className="alert alert-info" role="note">
        A PDF from the lab is more accurate than a photo. If you have the original PDF, upload that instead.
      </div>
    );
  }
  return (
    <div className="alert alert-warning" role="alert" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 4 }}>
      {problems.map((p) => <div key={p.code}>{p.message}</div>)}
      <div>Best of all: ask the lab for the original PDF. It is always more accurate than a photo.</div>
      <div style={{ fontWeight: 400 }}>
        You can still upload it, but it will be held for a navigator to read from the original, which takes longer.
      </div>
    </div>
  );
}
